import { sendMetric } from '@atheneum/api/dist/lib';
const sourceApp = 'scheduling';

function log(name, dimensions) {
  sendMetric(name, sourceApp, dimensions);
}

function wizardOpen(runningAt = 'ops') {
  log('wizard.open', {
    interface: runningAt
  });
}

function wizardClose(runningAt = 'ops') {
  log('wizard.close', {
    interface: runningAt
  });
}

function schedulerOpen(runningAt = 'ops') {
  log('scheduling.open', {
    interface: runningAt
  });
}

function wizardTimezone(runningAt = 'ops') {
  log('wizard.Timezone.change', {
    interface: runningAt
  });
}

function wizardTimeRange(runningAt = 'ops') {
  log('wizard.TimeRange.change', {
    interface: runningAt
  });
}

function wizardDuration(option, runningAt = 'ops') {
  log('wizard.Duration.change', {
    interface: runningAt,
    option
  });
}

function wizardDayRange(option, runningAt = 'ops') {
  log('wizard.DayRange.change', {
    interface: runningAt,
    option
  });
}

function wizardAddAvailabilities(type, runningAt = 'ops') {
  log('wizard.Availabilities.add', {
    type,
    interface: runningAt
  });
}

function interviewDurationChange(interviewDuration, runningAt = 'ops') {
  log('scheduling.InterviewDuration', {
    interface: runningAt
  });
}

function toggleMode(option, runningAt = 'ops') {
  log('scheduling.toggle', {
    interface: runningAt,
    option
  });
}

function wizardToggleType(type, runningAt = 'ops') {
  log('wizard.toggle', {
    type,
    interface: runningAt
  });
}

export default {
  interviewDurationChange,
  schedulerOpen,
  toggleMode,
  wizardAddAvailabilities,
  wizardClose,
  wizardDayRange,
  wizardDuration,
  wizardOpen,
  wizardTimeRange,
  wizardTimezone,
  wizardToggleType
};